import { call, put, takeEvery } from "redux-saga/effects"

import { 
    GET_ANONYMOUS_EXAM_RECORDS, 
    ADD_NEW_ANONYMOUS_EXAM_RECORD, 
    UPDATE_ANONYMOUS_EXAM_RECORD, 
    DELETE_ANONYMOUS_EXAM_RECORD ,


    GET_ANONYMOUS_RECORDS_FOR_TEACHER,
    GET_ANONYMOUS_RECORDS_FOR_TEACHER_SUCCESS,
    GET_ANONYMOUS_RECORDS_FOR_TEACHER_FAILURE,

    //LAST ADD FOR SEARCH BY BARCODE
    GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE,
    UPDATE_ANONYMOUS_EXAM_RECORD_NOTE,
    

    // FOR GENERATE ANONYMOUS RECORDS
    GENERATE_ANONYMOUS_RECORDS

} from "./actionTypes";
import {
    getAnonymousExamRecordsSuccess,
    getAnonymousExamRecordsFail,
    addAnonymousExamRecordSuccess,
    addAnonymousExamRecordFail,
    updateAnonymousExamRecordSuccess,
    updateAnonymousExamRecordFail,
    deleteAnonymousExamRecordSuccess,
    deleteAnonymousExamRecordFail,

    getAnonymousRecordsForTeacherSuccess,
    getAnonymousRecordsForTeacherFail,

    // LAST ADD FOR SEARCH BY BARCODE
    getAnonymousExamRecordByBarcodeSuccess,
    getAnonymousExamRecordByBarcodeFail,
    updateAnonymousExamRecordNoteSuccess,
    updateAnonymousExamRecordNoteFail,

    // FOR GENERATE ANONYMOUS RECORDS
    generateAnonymousRecordsSuccess,
    generateAnonymousRecordsFail,

    getAnonymousExamRecords as onGetAnonymousExamRecords,
   


   
} from "./actions"

import {
    getAnonymousExamRecords,
    addNewAnonymousExamRecord,
    updateAnonymousExamRecord,
    deleteAnonymousExamRecord,

    getAnonymousExamRecordsForTeacher,

    //LAST ADD FOR SEARCH BY BARCODE
    getAnonymousExamRecordByBarcode ,
    updateAnonymousExamRecordNote,

    generateAnonymousRecords

   
} from "helpers/anonymous-exam-records/anonymous_exam_records_backend_helper";
import { toast } from "react-toastify";


/*
function* fetchAnonymousExamRecords() {
    try {
        const response = yield call(getAnonymousExamRecords)
        yield put(getAnonymousExamRecordsSuccess(response))
    } catch (error) {
        yield put(getAnonymousExamRecordsFail(error))
    }
}
*/

function* fetchAnonymousExamRecords({ payload }) {

    console.log("PAYLOAD BEFORE GET ANONYMOUS EXAM RECORDS: ", payload);
    try {

        // On extrait l'uuid et on garde le reste pour les filtres
        const { evaluation_uuid, ...filters } = payload || {};


        const response = yield call(getAnonymousExamRecords, evaluation_uuid, filters)
        yield put(getAnonymousExamRecordsSuccess(response))
    } catch (error) {
        yield put(getAnonymousExamRecordsFail(error))
    }
}

function* onAddNewAnonymousExamRecord({ payload }) {
    try {

        
        const response = yield call(addNewAnonymousExamRecord, payload)

        //console.log("RESPONSE:", response);
        yield put(addAnonymousExamRecordSuccess(response.anonymousExamRecord))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        //console.log("ERROR:", error);
        yield put(addAnonymousExamRecordFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}



function* onUpdateAnonymousExamRecord({ payload}) {
    try {
        //console.log("UPDATE: ", payload);
        const response = yield call(updateAnonymousExamRecord, payload)
        yield put(updateAnonymousExamRecordSuccess(response.anonymousExamRecord))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(updateAnonymousExamRecordFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

function* onDeleteAnonymousExamRecord({ payload: data }) {

    try {
        const response = yield call(deleteAnonymousExamRecord, data)
        yield put(deleteAnonymousExamRecordSuccess(response.anonymousExamRecordId))
        toast.success(response.message, { autoClose: 2000 });
    } catch (error) {
        yield put(deleteAnonymousExamRecordFail(error))
        toast.error(error.response?.data?.message, { autoClose: 2000 });
    }
}

export function* fetchAnonymousRecordsForTeacher({ payload }) {
  try {
    // payload peut contenir { barcode } ou être vide pour récupérer toutes les records de l’enseignant
    const response = yield call(getAnonymousExamRecordsForTeacher, payload || {});

    yield put(getAnonymousRecordsForTeacherSuccess(response.anonymousExamRecords));
  } catch (error) {
    yield put(getAnonymousRecordsForTeacherFail(error));
  }
}


// LAST ADD FOR SEARCH BY BARCODE
// Saga pour récupérer un enregistrement par code-barre
/*function* fetchAnonymousExamRecordByBarcode({ payload: barcode }) {
    try {
        const response = yield call(getAnonymousExamRecordByBarcode, barcode);
        yield put(getAnonymousExamRecordByBarcodeSuccess(response));
    } catch (error) {
        yield put(getAnonymousExamRecordByBarcodeFail(error.message || "Erreur lors de la recherche"));
    }
}*/

function* fetchAnonymousExamRecordByBarcode({ payload: barcode }) {
    try {
        const response = yield call(getAnonymousExamRecordByBarcode, barcode);
        // On passe response.data (le record) et non response (qui contient success: true)
        yield put(getAnonymousExamRecordByBarcodeSuccess(response.data)); 
    } catch (error) {
        // Si Laravel renvoie 404, le message est dans error.response.data.message
        const message = error.response?.data?.message || "Erreur de recherche";
        yield put(getAnonymousExamRecordByBarcodeFail(message));
    }
}

// Saga pour mettre à jour la note
function* onUpdateAnonymousExamRecordNote({ payload: data }) {
    try {
        const response = yield call(updateAnonymousExamRecordNote, data);
        yield put(updateAnonymousExamRecordNoteSuccess(response));
    } catch (error) {
        yield put(updateAnonymousExamRecordNoteFail(error.message || "Erreur lors de la mise à jour"));
    }
}


// FOR GENERATE ANONYMOUS RECORDS
function* onGenerateAnonymousRecordsLAST({ payload: uuid }) {
    try {
        // L'appel au helper avec le nouveau nom si tu le souhaites
        const response = yield call(generateAnonymousRecords, uuid);
        yield put(generateAnonymousRecordsSuccess(response));
        
        toast.success(`${response.new_generated} fiches générées avec succès !`);
        
        // Rafraîchir la liste
        yield put(getAnonymousExamRecords({ evaluation_uuid: uuid }));
        
    } catch (error) {
        yield put(generateAnonymousRecordsFail(error));
        toast.error("Erreur lors de la génération des fiches.");
    }
}

// FOR GENERATE ANONYMOUS RECORDS
function* onGenerateAnonymousRecords({ payload: evaluationUuid }) {
    try {
        // 1. Appel API de génération
        const response = yield call(generateAnonymousRecords, evaluationUuid);
        yield put(generateAnonymousRecordsSuccess(response));
        
        toast.success(`${response.new_generated} fiches générées avec succès !`);
        
        // 2. RAFRAÎCHISSEMENT : On utilise l'ACTION Redux (avec l'alias)
        // Vérifie bien si ton API attend 'evaluation_uuid' ou 'evaluation_id'
        yield put(onGetAnonymousExamRecords({ evaluation_uuid: evaluationUuid }));
        
    } catch (error) {
        yield put(generateAnonymousRecordsFail(error));
        // Optionnel : ne mettre le toast que si ce n'est pas une erreur de validation
        // car le backend renvoie souvent des messages précis
        toast.error("Erreur lors de la génération des fiches.");
    }
}



function* anonymousExamRecordSaga() {
    yield takeEvery(GET_ANONYMOUS_EXAM_RECORDS, fetchAnonymousExamRecords)
    yield takeEvery(ADD_NEW_ANONYMOUS_EXAM_RECORD, onAddNewAnonymousExamRecord)
    yield takeEvery(UPDATE_ANONYMOUS_EXAM_RECORD, onUpdateAnonymousExamRecord)
    yield takeEvery(DELETE_ANONYMOUS_EXAM_RECORD, onDeleteAnonymousExamRecord)
    yield takeEvery(GET_ANONYMOUS_RECORDS_FOR_TEACHER, fetchAnonymousRecordsForTeacher);

    // LAST ADD FOR SEARCH BY BARCODE
    yield takeEvery(GET_ANONYMOUS_EXAM_RECORD_BY_BARCODE, fetchAnonymousExamRecordByBarcode);
    yield takeEvery(UPDATE_ANONYMOUS_EXAM_RECORD_NOTE, onUpdateAnonymousExamRecordNote);

    // FOR GENERATE ANONYMOUS RECORDS
    yield takeEvery(GENERATE_ANONYMOUS_RECORDS, onGenerateAnonymousRecords);
}

export default anonymousExamRecordSaga;